if (!customElements.get("marquee-component")) {
class MarqueeComponent extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(".marquee__track");
    this.originalItems = Array.from(this.querySelectorAll(".marquee__item"));
    this.originalItems.forEach(item => item.classList.add('marquee__item--original'));

    this.loop = null;
    this.gsapCtx = null;
    this.lastWidth = 0;
    this.resizeTimeout = null;

    this.handleMouseEnter = () => { if (this.loop) this.loop.pause(); };
    this.handleMouseLeave = () => { if (this.loop) this.loop.play(); };
    this.handleFocusIn = () => { if (this.loop) this.loop.pause(); };
    this.handleFocusOut = () => { if (this.loop) this.loop.play(); };

    if (this.dataset.pauseOnHover === "true") {
      this.addEventListener("mouseenter", this.handleMouseEnter);
      this.addEventListener("mouseleave", this.handleMouseLeave);
    }
    this.addEventListener("focusin", this.handleFocusIn);
    this.addEventListener("focusout", this.handleFocusOut);

    requestAnimationFrame(() => this.initMarquee());

    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const currentWidth = this.offsetWidth;
        if (currentWidth && currentWidth !== this.lastWidth) {
          this.reinitMarquee();
        }
      }, 150);
    });
    this.resizeObserver.observe(this);
  }

  initMarquee() {
    const containerWidth = this.offsetWidth;
    if (!containerWidth) return;

    let totalItemsWidth = 0;
    this.originalItems.forEach(item => {
      totalItemsWidth += item.offsetWidth;
    });
    if (!totalItemsWidth) return;

    this.lastWidth = containerWidth;

    const minWidth = containerWidth * 2;
    let duplications = Math.ceil(minWidth / totalItemsWidth);
    duplications = Math.max(duplications, 2);

    const frag = document.createDocumentFragment();
    for (let i = 1; i < duplications; i++) {
      this.originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.remove('marquee__item--original');
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("tabindex", "-1");
        frag.appendChild(clone);
      });
    }
    this.track.appendChild(frag);

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!window.animations_enabled || prefersReducedMotion || parseFloat(this.dataset.speed) === 0) return;

    const allItems = this.querySelectorAll(".marquee__item");

    this.gsapCtx = gsap.context(() => {
      this.loop = horizontalLoop(allItems, {
        repeat: -1,
        speed: parseFloat(this.dataset.speed) || 1,
        reversed: this.dataset.reversed === "true"
      });
    });
  }

  reinitMarquee() {
    if (this.gsapCtx) {
      this.gsapCtx.revert();
      this.gsapCtx = null;
    }
    this.loop = null;

    const clonedItems = this.track.querySelectorAll('.marquee__item:not(.marquee__item--original)');
    clonedItems.forEach(item => item.remove());

    if (window.gsap) {
      gsap.set(this.originalItems, { clearProps: "all" });
    }

    this.initMarquee();
  }

  disconnectedCallback() {
    if (this.gsapCtx) this.gsapCtx.revert();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    clearTimeout(this.resizeTimeout);
  }
}

customElements.define("marquee-component", MarqueeComponent);
}
